import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../../../Context/store/context";
import Theme from "./Theme";
import { _get } from "../../../../apiClient";
import { _showToast } from "../../../../toastHelper";
import globals from "../../../../globals";
import config from "../../../../config";

export default function Themes() {
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } =
    useAuth();
  const [themes, setThemes] = useState([]);
  const [isForDemo, setIsForDemo] = useState(false);
  const [isForWebsite, setIsForWebsite] = useState(false);
  const [isWebsiteChangeTheme, setIsWebsiteChangeTheme] = useState(false);
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  let { id, eventId, profileId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) logoutuser();
    updateTitleAndIcon(globals.selectTheme.title, globals.selectTheme.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      let forDemo = false;
      let forWebsite = false;
      const pathname = window.location.pathname;

      if (!id && pathname.startsWith("/create-demo")) {
        id = config.demoCategoryId;
        forDemo = true;
        setIsForDemo(true);
      } else if (id === config.demoCategoryId) {
        forDemo = true;
        setIsForDemo(true);
      }

      if (!id && pathname.startsWith("/create-website")) {
        id = config.websiteCategoryId;
        forWebsite = true;
        setIsForWebsite(true);
      } else if (id === config.websiteCategoryId) {
        if (!pathname.startsWith("/change-website-theme")) {
          forWebsite = true;
        } else if (pathname.startsWith("/change-website-theme")) {
          setIsWebsiteChangeTheme(true);
        }
        setIsForWebsite(true);
      }

      if (forWebsite) {
        if (!userDetails.domain || (userDetails.domain && userDetails.domain.trim() == "")) {
          _showToast("Please complete the domain information", "info");
          return navigate("/domains");
        }
      }

      if (forDemo || forWebsite) {
        checkandfetch(forDemo, id);
      } else {
        fetchThemes(id);
      }
    }
  }, [userDetails]);

  const checkandfetch = async (fordemo, id) => {
    if (fordemo) {
      await checkStatus(id);
    } else {
      const websiteId = userDetails.profilePageId;
      if (websiteId) {
        navigate("/website/" + websiteId);
      } else {
        fetchThemes(id);
      }
    }
  };

  const checkStatus = async (id) => {
    showLoader();
    await _get(`/events/check-status?isForDemo=true`)
      .then(async () => {
        hideLoader();
        await fetchThemes(id);
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
        return navigate("/demos");
      });
  };

  const fetchThemes = async (categoryId) => {
    showLoader();
    await _get("/themes/bycategory/" + categoryId)
      .then((response) => {
        setThemes(response);
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  };

  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="card mb-3">
          <div className="card-body">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-style1 mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard" className="text-gray">
                    Dashboard
                  </NavLink>
                </li>
                {!isForDemo && !isForWebsite && !isWebsiteChangeTheme && (
                  <>
                    <li className="breadcrumb-item">
                      <NavLink to="/invitations" className="text-gray">
                        My Invitations
                      </NavLink>
                    </li>
                    {!eventId && (
                      <li className="breadcrumb-item ">
                        <NavLink to="/create-invitation" className="text-gray">
                          Invitation Type
                        </NavLink>
                      </li>
                    )}
                    <li className="breadcrumb-item text-primary">
                      Select Theme
                    </li>
                  </>
                )}
                {isForDemo && (
                  <>
                    <li className="breadcrumb-item">
                      <NavLink to="/demos" className="text-gray">
                        My Demos
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item text-primary">
                      Select Theme
                    </li>
                  </>
                )}

                {(isForWebsite || isWebsiteChangeTheme) && (
                  <>
                    <li className="breadcrumb-item text-primary">
                      Select Theme
                    </li>
                  </>
                )}
              </ol>
            </nav>
          </div>
        </div>

        <div className="row g-3">
          {themes &&
            themes.map((item, index) => {
              return (
                <Theme
                  theme={item}
                  key={index}
                  eventId={eventId}
                  profileId={profileId}
                  isForDemo={isForDemo}
                  isForWebsite={isForWebsite}
                  profileUrl={userDetails.domain}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
}
